export default {
  fonts: {
    sans: `"calluna-sans", sans-serif`,
    serif: `"calluna", serif`
  },
  colors: {
    bg: '#ecedee',
    darkTeal: '#003A47',
    teal: '#007D9B',
    lightTeal: '#C6E2E8',
    black: '#354144',
    muted: '#808a8d',
    darkBlack: '#151b19'
  },
  app: {
    headerWidth: '14rem',
    mobileBreakpoint: '48rem'
  }
}


// WEBPACK FOOTER //
// ./src/utils/theme.js